import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Settings } from './components';
import useCampaign from './useCampaign';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: theme.spacing(3)
  }
}));

const CampaignSettings = props => {
  const campaign = useCampaign('/campaigns/edit');
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <Settings campaign={campaign} showNav={true} />
      </div>
    </div>
  );
};

export default CampaignSettings;
